import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, useTableState } from '#pie/components/table/Table';
import type { TicketsColumnName } from '#pie/components/ticket-table/TicketTable';
import { ticketsColumnParse } from '#pie/components/ticket-table/TicketTable';
import { useGetTicket } from '#pie/internal/api/pie-bff';
import { parseDates } from '#pie/utils/date';

export const TicketTableEan: React.FC<{ ean?: string }> = ({ ean }) => {
  const { t } = useTranslation('ticket');
  const { onPaginationChange, onSortingChange, pagination, sorting } =
    useTableState({
      defaultSort: [
        {
          desc: true,
          id: 'createdOn',
        },
      ],
      pageSizes: [5, 10],
    });

  const { data, isLoading } = useGetTicket(
    {
      filter: {
        ean18: ean,
        ticketView: 'All',
      },
      pagination,
      sorting: sorting[0] && {
        descending: sorting[0].desc,
        field: sorting[0].id,
      },
    },
    {
      query: {
        select: (data) => ({
          ...data,
          items: data.items?.map((item) =>
            parseDates(item, [
              'createdOn',
              'eventDate',
              'targetDate',
              'modifiedOn',
              'handledByRegionalGridOperatorDate',
            ]),
          ),
        }),
      },
    },
  );

  const columns: readonly TicketsColumnName[] = [
    'ticketNumber',
    'title',
    'regionalGridOperator',
    'status',
    'createdOn',
  ];

  const pageCount =
    data?.totalCount && data.totalCount
      ? Math.ceil(data.totalCount / pagination.pageSize)
      : -1;

  return isLoading || (ean && !!(data?.totalCount && data?.totalCount > 0)) ? (
    <Suspense>
      <Table
        label={`Tickets voor EAN ${ean}`}
        pagination={pagination}
        sorting={sorting}
        rowLinks={(row) => ({
          'aria-label': row.original.ticketNumber,
          target: '_blank',
          to: `/berichtenbox/${row.original.id}`,
        })}
        columns={columns.map(
          (columnName) => ticketsColumnParse({})[columnName],
        )}
        data={data?.items}
        isLoading={isLoading && 5}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        totalCount={data?.totalCount}
        getSortedRowModel={undefined}
        getFilteredRowModel={undefined}
        pageCount={pageCount}
      />
    </Suspense>
  ) : (
    t('create.prior_tickets.other_tickets')
  );
};
